module.exports = __webpack_public_path__ + "img/global-pool.4bdccd4.png";